module.exports = __webpack_public_path__ + "img/钱坤云.f03aa2dc.png";